<label class="toggle">
    <input type="checkbox" [checked]="value" (change)="toggle()" />
    <span class="slider"></span>
</label>